// Decorative SVG ornaments used across the site.
// Pure SVG so they remain crisp and lightweight.
import React from "react";

export const WaveDivider = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 1200 40"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M0,20 C150,40 300,0 450,20 C600,40 750,0 900,20 C1050,40 1200,0 1200,20 L1200,40 L0,40 Z"
      fill="rgba(201,162,90,0.18)"
    />
    <path
      d="M0,22 C150,4 300,38 450,22 C600,6 750,38 900,22 C1050,6 1200,38 1200,22"
      fill="none"
      stroke="rgba(201,162,90,0.45)"
      strokeWidth="1"
    />
  </svg>
);

export const Compass = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      cx="50"
      cy="50"
      r="46"
      fill="none"
      stroke="rgba(201,162,90,0.55)"
      strokeWidth="0.8"
    />
    <circle
      cx="50"
      cy="50"
      r="38"
      fill="none"
      stroke="rgba(201,162,90,0.3)"
      strokeWidth="0.5"
    />
    <g className="compass-spin" style={{ transformOrigin: "50px 50px" }}>
      {Array.from({ length: 16 }).map((_, i) => (
        <line
          key={i}
          x1="50"
          y1="6"
          x2="50"
          y2={i % 4 === 0 ? "14" : "10"}
          stroke="rgba(201,162,90,0.5)"
          strokeWidth={i % 4 === 0 ? 1 : 0.5}
          transform={`rotate(${i * 22.5} 50 50)`}
        />
      ))}
    </g>
    <polygon
      points="50,18 54,50 50,82 46,50"
      fill="rgba(201,162,90,0.85)"
      opacity="0.9"
    />
    <polygon
      points="50,18 54,50 50,50"
      fill="rgba(243,220,160,0.95)"
    />
    <circle cx="50" cy="50" r="3" fill="#c9a25a" />
    <text
      x="50"
      y="11"
      textAnchor="middle"
      fontSize="6"
      fill="rgba(242,232,213,0.7)"
      fontFamily="Cinzel, serif"
    >
      N
    </text>
  </svg>
);

export const OrnamentDivider = ({ label }) => (
  <div className="divider-ornament w-full max-w-md mx-auto my-10">
    <span className="line" />
    <svg
      width="32"
      height="14"
      viewBox="0 0 32 14"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M0,7 L10,7 M22,7 L32,7"
        stroke="rgba(201,162,90,0.7)"
        strokeWidth="1"
      />
      <circle cx="16" cy="7" r="3.5" fill="none" stroke="#c9a25a" strokeWidth="1" />
      <circle cx="16" cy="7" r="1.2" fill="#c9a25a" />
    </svg>
    <span className="line" />
    {label ? (
      <span className="font-accent text-[10px] text-[#c9a25a]/80">
        {label}
      </span>
    ) : null}
  </div>
);
